
import EventManager from "../../../manager/event_manager";
import TextureManager from "../../../manager/texture_manager";
import Utility from "../../../utility/utility";
import SpriteFrameHolder from "../../public/ui/spriteFrameHolder";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubInfoItem extends cc.Component {
    @property(cc.Label)
    clubCount:cc.Label = null

    @property(cc.Label)
    clubNumber:cc.Label = null

    @property(cc.Sprite)
    bgSpr:cc.Sprite = null

    @property(SpriteFrameHolder)
    bgHolder:SpriteFrameHolder = null


    clubData = null

    onLoad(){
        this.bgSpr.node.on("click", this.onClickEnterEvent, this)
    }



    setData( data: any, index){
        let self = this
        this.clubData = data
        this.node.active = true
        this.clubCount.string = data.userNum
        this.clubNumber.string = data.clubNum
        if(Utility.isJSON(data.desc)){
            let desc = JSON.parse(data.desc);
            let sp = this.bgHolder.getSpriteFrameByKey(desc.logo)
            if(sp == null){
                sp = this.bgHolder.getSpriteFrameByKey("1")
            }
            if(sp){
                this.bgSpr.spriteFrame = sp
            }
        }
        this.node.opacity = 0
        this.node.runAction(cc.fadeIn(0.3))
    }

    onClickEnterEvent(){
        if (this.clubData == null){
            return
        }
        let self = this
        this.node.runAction(cc.fadeTo(0.3, 100))
        this.scheduleOnce(()=>{
            EventManager.instance.dispatch("IN_CLUB_EVENT", this.clubData)
        }, 0.3)
        
    }

    onDisable(){
        this.unscheduleAllCallbacks()
    }
    // update (dt) {}
}
